import { Column } from '../../models/column.model';
import { LigneParametrage } from './ligne-parametrage.interface';
import { get } from 'lodash';

export class ColonneParametrage extends Column {

	editable: boolean;
	largeur: string;
	ellipsis: boolean;

	/**
	 * Retourne la valeur de la colonne pour la ligne de paramétrage.
	 *
	 * @param ligne le ligne de paramétrage.
	 */
	getValeur(ligne: LigneParametrage) {
		return get(ligne, this.key);
	}

	deserialize(input: any): this {
		Object.assign(this, input);
		return this;
	}

}
